import * as TYPES from "./constants";

export const openModal = (id: number | string, extra: any) => dispatch => {
  dispatch({ type: TYPES.MODAL_OPEN, id, extra });
  return Promise.resolve();
};

export const closeModal = () => dispatch => {
  dispatch({ type: TYPES.MODAL_CLOSE });
  return Promise.resolve();
};

export const changeHighlight = ({
  id,
  name,
}: {
  id: string | number,
  name: string,
}) => dispatch => {
  dispatch({ type: TYPES.CHANGE_HIGHLIGHT, id, name });
  const highlights = localStorage.highlights ? JSON.parse(localStorage.highlights) : {};
  highlights[name] = id;
  localStorage.setItem("highlights", JSON.stringify(highlights));
};



// WEBPACK FOOTER //
// ./src/ducks/ui/actions.js